/// 只弹一次 (有效期1天)
export class LotteryConfig {
  static minPerson = 100;

  static notWinning = "notWinning";
  static winning = "winning";
  private static show = "false";
  private static hide = "true";

  static cherrytotalCount = 806;

  static setWinningToast(key: string, value: string) {
    return localStorage.setItem(key, value);
  }
  static getShowWinningToast(value: string): boolean {
    if (localStorage.getItem(value) == null) {
      this.setWinningToast(value, this.show);
      return true;
    }
    if (this.isSunday()) {
      this.setWinningToast(value, this.show);
    }
    if (localStorage.getItem(value) == this.show) {
      this.setWinningToast(value, this.hide);
      return true;
    }
    return false;
  }

  private static isSunday() {
    const now = new Date();
    // 星期天
    return now.getDay() == 0;
  }
}
